import {ReactNode} from "react";
import {Box, Colors, Text} from "@bounce/shared/ui";

interface TooltipRowProps {
  marker?: ReactNode;
  children: ReactNode;
}

export const TooltipRow = ({marker, children}: TooltipRowProps) => (
  <Box sx={{display: "flex", alignItems: "flex-start", gap: 1}}>
    {marker}
    <Text size={12} sx={{color: Colors.grey._600, lineHeight: 1.45}}>
      {children}
    </Text>
  </Box>
);
